import React, { useEffect, useState } from "react";
import { sendCode, saveVipMember } from "../../api/api";
import { privacyPolicy } from "../../const";
import logoPng from "./../../asset/img/question2.png";
import cityJson from "./../../asset/region.json";
import styles from "./index.module.less";
// import {  } from "react-vant/es/form";
import {
  Form,
  Field,
  Popup,
  Picker,
  Button,
  Notify,
  Divider,
  Dialog,
  Checkbox,
  Toast,
} from "react-vant";
import { debounce } from "lodash";

// import styled from 'styled-component';

// export const FormWrapper=styled.div`

// `

const columnsFieldNames = {
  text: "name",
  children: "children",
  code: "code",
};

const sortBusiness = ["个人", "全国连锁", "区域连锁", "其他"];

type FormData = {
  /** 姓名 */
  f_RealName: string;
  /** 手机号 */
  f_Mobile: string;
  /** 机构名称 */
  f_CompanyName: string;
  /** 省份 */
  f_Province: string;
  f_City: string;
  /** 机构经营类别 */
  f_ProductType: string;
  /** 内容,空格隔开为一个类型 */
  f_NeedLearn: string;
  /** 手机验证码 */
  F_VerificationCode: string;
};
/**
 * wechat 专用，保存VIP用户
 * @returns
 */
export const Questionnaire = () => {
  const [content, setContent] = React.useState<string[]>([]);
  const [visible, setVisible] = React.useState(false);
  const [isCheck, setIsCheck] = React.useState(false);
  const [currentS, setCurrentS] = React.useState(0);
  const [sms, setSms] = React.useState<string | undefined>(undefined);
  const [form] = Form.useForm();
  const [area, set] = useState({
    visible: false,
    value: "",
    code: "",
  });
  const [sortBusinessValue, handleSortBusiness] = useState<{
    visible: boolean;
    value: string;
    name: string;
  }>({
    visible: false,
    value: "",
    name: "",
  });

  /** 保存用户 */
  const onFinish = () => {
    const { validateFields } = form;
    validateFields()
      .then((values) => {
        // 校验成功进then
        saveVipMember({
          ...values,
          f_Province: area.code.split(" ")[0],
          f_city: area.code.split(" ")[1],
          f_NeedLearn: content.join(" "),
          f_ProductType: sortBusinessValue.value,
        }).then((res: any) => {
          if (res.code === 200) {
            Toast.success("提交成功");
          }
        });
      })
      .catch((err) => {
        Toast.fail("提交保存失败");
      });
  };

  useEffect(() => {
    document.title = "合作咨询";
  }, []);

  useEffect(() => {
    if (currentS > 0) {
      setTimeout(() => disableCode(currentS - 1), 1000);
    }
    // 这里是不是清除掉定时器
  }, [currentS]);

  const handleSort = (sort: string) => {
    if (content.includes(sort)) {
      setContent(() => content.filter((item) => item !== sort));
      return;
    }
    setContent([...content, sort]);
  };

  /** 发送验证码 */
  const sendSms = () => {
    const { validateFields } = form;
    validateFields(["f_Mobile"]).then((value) => {
      requireCode();
    });
  };

  const requireCode = () => {
    sendCode(form.getFieldValue("f_Mobile")).then((res: any) => {
      if (res.code !== 200) {
        Notify.show({ type: "danger", message: "获取验证码失败" });
        return;
      }
      disableCode(60);
    });
  };

  // 60s 倒计时
  const disableCode = (currentS: number) => {
    setCurrentS(currentS);
  };

  const handleCheckboxChange = (e: any) => {
    console.log("e", e);
    setIsCheck(e);
  };

  return (
    <div className={styles.wrapper} id="question-wrapper">
      <div className={styles.header}>
        <img style={{ width: "100%" }} src={logoPng} alt="logo" />
      </div>
      <div className={styles.content}>
        <Form onFinish={debounce(onFinish, 1000)} form={form}>
          <h4>您的基本信息</h4>
          <Form.Item
            name="f_RealName"
            rules={[
              { type: "string", required: true, message: "请输入你的姓名" },
            ]}
          >
            <Field placeholder="姓名" />
          </Form.Item>
          <Form.Item
            name="f_Mobile"
            rules={[
              {
                validator: (_, value) => {
                  const reg1 = /^[0-9]*$/;
                  const reg2 = /^[1][3,4,5,7,8][0-9]{9}$/;
                  if (!reg1.test(value) || !reg2.test(value)) {
                    return Promise.reject(new Error("请输入正确的手机号码"));
                  }
                  return Promise.resolve(true);
                },
              },
              {
                required: true,
              },
            ]}
          >
            <Field placeholder="手机号:" />
          </Form.Item>
          <Form.Item
            name="F_VerificationCode"
            rules={[
              { type: "string", required: true, message: "请填写短信验证码" },
            ]}
          >
            <Field
              value={sms}
              center
              clearable
              placeholder="请输入短信验证码"
              onChange={setSms}
              button={
                <Button
                  size="small"
                  style={{ width: "24vw" }}
                  color="#3C4B91"
                  onClick={sendSms}
                  type="primary"
                  disabled={currentS > 0}
                >
                  {currentS > 0 ? `${currentS}s` : "发送验证码"}
                </Button>
              }
            />
          </Form.Item>
          <h4>您的机构信息</h4>
          <Form.Item
            name="f_CompanyName"
            rules={[
              { type: "string", required: true, message: "请输入您的机构名称" },
            ]}
          >
            <Field placeholder="机构名称" />
          </Form.Item>
          <h5>机构所在地</h5>
          <>
            <Field
              isLink
              readonly
              value={area.value}
              placeholder="请选择城市区域"
              onClick={() => set(() => ({ ...area, visible: true }))}
            />
            <Popup
              round
              visible={area.visible}
              position="bottom"
              onClose={() => set(() => ({ ...area, visible: false }))}
            >
              <Picker
                title="请选择城市区域"
                onConfirm={(value: Array<any>) => {
                  set({
                    visible: false,
                    value: `${value[0].name} ${value[1].name} ${value[2].name}`,
                    code: `${value[0].code} ${value[1].code} ${value[2].code}`,
                  });
                }}
                onCancel={() =>
                  set(() => ({
                    ...area,
                    visible: false,
                  }))
                }
                columnsFieldNames={columnsFieldNames}
                columns={cityJson}
              />
            </Popup>
          </>
          <>
            <Field
              isLink
              readonly
              value={sortBusinessValue.name}
              placeholder="选择机构经营类别"
              onClick={() =>
                handleSortBusiness(() => ({
                  ...sortBusinessValue,
                  visible: true,
                }))
              }
            />
            <Popup
              round
              visible={sortBusinessValue.visible}
              position="bottom"
              onClose={() =>
                handleSortBusiness(() => ({
                  ...sortBusinessValue,
                  visible: false,
                }))
              }
            >
              <Picker
                columns={sortBusiness}
                title="选择机构经营类别"
                onCancel={() =>
                  handleSortBusiness(() => ({
                    ...sortBusinessValue,
                    visible: false,
                  }))
                }
                // @ts-ignore
                onConfirm={(value: string, index: number) => {
                  handleSortBusiness(() => ({
                    visible: false,
                    value: (index + 1).toString(),
                    name: value,
                  }));
                }}
              />
            </Popup>
          </>
          <h4>您想了解的内容（多选）</h4>
          <div className="lerna">
            <div
              className={content.includes("产品介绍") ? "active" : "default"}
              onClick={() => handleSort("产品介绍")}
            >
              产品介绍
            </div>
            <div
              className={content.includes("产品体验") ? "active" : "default"}
              onClick={() => handleSort("产品体验")}
            >
              产品体验
            </div>
            <div
              className={content.includes("商务合作") ? "active" : "default"}
              onClick={() => handleSort("商务合作")}
            >
              商务合作
            </div>
            <div
              className={content.includes("其他") ? "active" : "default"}
              onClick={() => handleSort("其他")}
            >
              其他
            </div>
          </div>
        </Form>
        <Divider />
        <Checkbox
          defaultChecked
          shape="square"
          checkedColor="#6786b8"
          onChange={handleCheckboxChange}
        >
          我已阅读并同意{" "}
          <a
            style={{ textDecoration: "underline", color: "#6786b8" }}
            onClick={() =>
              Dialog.alert({
                message: `${privacyPolicy}`,
                theme: "round-button",
                messageAlign: "left",
              })
            }
          >
            用户协议和隐私条款
          </a>
        </Checkbox>
        <Button
          style={{ width: "100%", margin: "48px 0" }}
          color="#3C4B91"
          round
          nativeType="submit"
          onClick={debounce(onFinish, 1200)}
          type="primary"
        >
          提交
        </Button>
      </div>
    </div>
  );
};
